import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSyncComponent } from "./med-icon-sync.component";

@NgModule({
  declarations: [
    MedIconSyncComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSyncComponent,
  ],
})
export class MedIconSyncModule { }
